import type * as openapi from '@/helpers/api/types/openapiOverrides';

export interface TimeObject {
  hours: number;
  minutes: number;
  seconds?: number;
}

export interface StateTimeZone {
  timezone: string;
  code: string;
}

export type StatesTimeZonesMap = Record<string, StateTimeZone>;

// prettier-ignore
export interface CustomerItem extends Pick<
  openapi.GetJobeditJob_200,
  | 'caller'
  | 'phone'
  | 'reference_1'
  | 'reference_2'
  | 'reference_3'
  | 'reference_4'
> {
  customer_code: openapi.GetJobeditJob_200['customer'];
}

export function createEmptyCustomerItem(): CustomerItem {
  return {
    customer_code: '',
    caller: '',
    phone: '',
    reference_1: '',
    reference_2: '',
    reference_3: '',
    reference_4: '',
  };
}

export type StopItem = openapi.StopOpenapi;

export function createEmptyStopItem(): StopItem {
  return {
    stop_number: 1,
    name: '',
    address_line_1: '',
    address_line_2: '',
    suburb: '',
    post_code: '',
    state: '',
    arrived_at: null,
    departed_at: null,
    required_at: '',
    pod_time: null,
    pod_name: null,
    is_pod_image: false,
    driver_is: 0,
    attributes: [],
    instructions: '',
    time_earliest: null,
    time_latest: null,
    services: [],
    app_images: [],
    pickup_products: {},
    delivery_products: {},
    can_schedule: false,
    is_warehouse: false,
    note_text: null,
    note_name: null,
    note_phone: null,
    note_email: null,
    schedule_start: null,
    schedule_finish: null,
    assigned_technician: null,
    assigned_at: null,
    duration: 0,
  };
}

// Product type codes that the backend treats as custom — UI shows the
// dimensions alongside the model name for these.
export const CUSTOM_PRODUCT_TYPE_CODES: readonly string[] = ['CPAL', 'CBOX'];

export type JobEditProductItem = Pick<
  openapi.PutJobeditProducts_200,
  'model' | 'serial' | 'description' | 'pieces' | 'quant_id' | 'type_code'
> & {
  prefix?: string;
  model_id?: number | null;
  weight?: number | null;
  width?: number | null;
  height?: number | null;
  length?: number | null;
  volume?: string | null;
  // Legacy backend ordering field — must be round-tripped on save so the
  // server keeps existing line ordering and doesn't renumber on us.
  line_number?: number | null;
  picking_status?: openapi._ProductOpenapi['picking_status'];
};

export function createEmptyProductItem(): JobEditProductItem {
  return {
    prefix: '-',
    model: '',
    serial: '',
    description: null,
    pieces: 1,
    quant_id: null,
    type_code: '',
  };
}

export type JobEditServiceItem = openapi.PutJobeditServices_200[number] & {
  service_code?: string;
};

export function createEmptyServiceItem(): JobEditServiceItem {
  return {
    service_code: '',
    name: '',
    quantity: 1,
    second_quantity: 1,
    scheduled_fee: 0,
    fee: 0,
    gst: 0,
    pay: 0,
  };
}

export interface LegData {
  stopNumber: number;
  pickupStop: number;
  deliveryStop: number;
  products: JobEditProductItem[];
  services: JobEditServiceItem[];
  instructions: string;
}
